import { render } from "./PatientDocList.vue?vue&type=template&id=365d3006"
import script from "./PatientDocList.vue?vue&type=script&lang=js"
export * from "./PatientDocList.vue?vue&type=script&lang=js"

import "./PatientDocList.vue?vue&type=style&index=0&id=365d3006&lang=scss"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__